import axios from 'axios';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import {
      CardHeader,
      CardLinks,
      CardTitle
} from '../../styles/components/common/Table';
import { LinkButton } from '../../styles/components/common/Button';
import Input from '../../components/Form/Input';
import Select from '../../components/Form/Select';
import FormButton from '../../components/Form/Button';
import { useParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { Loading } from '../../components/Loading';

const ComplainTypeEdit = () => {
      const { complainTypeId } = useParams();
      const [loadingData, setLoadingData] = useState(false);

      const [title, setTitle] = useState('');
      const [status, setStatus] = useState('');
      const [loading, setLoading] = useState(false);

      const token = JSON.parse(localStorage.getItem('token'));

      const loadData = async () => {
            setLoadingData(true);
            await axios
                  .get(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/complain_types/${complainTypeId}`,
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              setTitle(response.data.type.title);
                              setStatus(response.data.type.status);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoadingData(false);
      };

      useEffect(() => {
            loadData();
      }, []);

      const handleForm = async (event) => {
            event.preventDefault();
            setLoading(true);
            const data = {
                  title: title,
                  status: status
            };

            await axios
                  .post(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/complain_types/${complainTypeId}`,
                        data,
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              toast.success(response.data.message);
                        }
                        if (response.data.result === 'error') {
                              if (response.data.message.title) {
                                    toast.error(response.data.message.title);
                              }
                              if (response.data.message.status) {
                                    toast.error(response.data.message.status);
                              }
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      return (
            <>
                  <Form onSubmit={handleForm}>
                        <Row>
                              <Col lg={12}>
                                    <Card>
                                          <CardHeader>
                                                <CardTitle>
                                                      Edit Complain Types
                                                </CardTitle>
                                                <CardLinks>
                                                      <LinkButton to="/dashboard/complains/types">
                                                            Back
                                                      </LinkButton>
                                                </CardLinks>
                                          </CardHeader>
                                          <Card.Body>
                                                {!loadingData ? (
                                                      <Row className="g-3">
                                                            <Input
                                                                  title="Title"
                                                                  classes={8}
                                                                  required={
                                                                        true
                                                                  }
                                                                  value={title}
                                                                  handleChange={
                                                                        setTitle
                                                                  }
                                                            />
                                                            <Select
                                                                  title="Status"
                                                                  classes={4}
                                                                  selected={
                                                                        status
                                                                  }
                                                                  setStatus={
                                                                        setStatus
                                                                  }
                                                            />
                                                            <Col lg={12}>
                                                                  <FormButton
                                                                        title="Submit"
                                                                        loading={
                                                                              loading
                                                                        }
                                                                  />
                                                            </Col>
                                                      </Row>
                                                ) : (
                                                      <>
                                                            <div
                                                                  className="text-center d-flex align-items-center justify-content-center w-100"
                                                                  style={{
                                                                        height: '30vh'
                                                                  }}
                                                            >
                                                                  <Loading />
                                                            </div>
                                                      </>
                                                )}
                                          </Card.Body>
                                    </Card>
                              </Col>
                        </Row>
                  </Form>
            </>
      );
};

export default ComplainTypeEdit;
